<template>
  <section v-loading.fullscreen.lock="loading">
    <div v-if="!loading && !getTestPreviewURL" class="link-error">
      <div class="inner">
        <div class="icon">
          <img src="../../assets/img/icons/link-expired.png" alt="" />
        </div>
        <h1>{{ getError || "Error in Getting Report" }}</h1>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters("cases", ["getUrineTestPreviewURL"]),
    ...mapGetters("errors", ["getError"]),
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.caseId = this.$route.params.case_id;
      await this.$store.dispatch("cases/previewUrineTestReport", {
        case_id: this.$route.params.case_id,
      });

      this.loading = false;
      if (this.getUrineTestPreviewURL) {
        document.write(this.getUrineTestPreviewURL);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.link-error {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    position: relative;
    img {
      width: 150px;
      margin: 0 auto;
      display: table;
    }
  }
  h1 {
    margin-top: 0.5em;
    font-size: 1.4em;
    font-weight: 600;
    color: #3084ec;
    text-align: center;
  }
}
</style>
